import { useEffect, useMemo, useState } from 'react'
import ItemPicker from './ItemPicker.jsx'

export default function RecipeLinkModal({
  recipeId,
  recipes,
  items,
  updateRecipeItemId,
  onClose,
  onLinked,
  onNavigateToItems,
}) {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const open = recipeId != null

  useEffect(() => {
    if (open) {
      setError(null)
      setSubmitting(false)
    }
  }, [open])

  const recipesByItemId = useMemo(() => {
    const m = new Map()
    for (const r of recipes || []) {
      if (!r.item_id) continue
      if (r.id === recipeId) continue
      const list = m.get(r.item_id) || []
      list.push(r)
      m.set(r.item_id, list)
    }
    return m
  }, [recipes, recipeId])

  async function handleSelect(item) {
    if (submitting) return
    const recipe = (recipes || []).find((r) => r.id === recipeId)
    if (!recipe) {
      setError('Recipe is no longer in your account')
      return
    }
    setSubmitting(true)
    setError(null)
    try {
      const { error: updErr } = await updateRecipeItemId(recipeId, item.id)
      if (updErr) {
        const msg = String(updErr.message || '')
        if (updErr.code === '23503' || /foreign key|violates/i.test(msg)) {
          setError('That item is no longer available. The list has been refreshed.')
        } else {
          setError("Couldn't save. Try again.")
        }
        return
      }
      onLinked?.({ itemName: item.name })
      onClose?.()
    } catch (e) {
      const msg = String(e?.message || '')
      if (e?.code === '23503' || /foreign key|violates/i.test(msg)) {
        setError('That item is no longer available. The list has been refreshed.')
      } else {
        setError("Couldn't save. Try again.")
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <ItemPicker
      mode="modal"
      open={open}
      items={items}
      value={null}
      onSelect={handleSelect}
      onClose={onClose}
      recipesByItemId={recipesByItemId}
      onNavigateToItems={onNavigateToItems}
      errorMessage={error}
      busy={submitting}
    />
  )
}
